export const APIKEY = 'c4e357e1a1580314';
export const API = 'https://api.wunderground.com/api/';



// WEBPACK FOOTER //
// ./src/config.ts